import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Workshops() {
  const [tab, setTab] = useState("standard");

  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">Workshops</h1>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16 space-y-12">
        <div>
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Overview</h2>
          <p className="text-slate-600 leading-relaxed">
            Dive into the world of NFC and gain insight into the ins and outs of the technology. In the standard
            course, over the course of two days you will learn the difference between NFC and RFID, the NFC operating
            modes, the different type of tags, tag memory structure, and how to read/write to the different type of
            NFC tags.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            The training can be offered at your corporate office. Within the Greater Toronto Area, there will be no
            additional travel fee. Contact us to learn more or request a quote.
          </p>
        </div>

        <div>
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Audience</h2>
          <p className="text-slate-600 leading-relaxed">
            This training is targeted towards firms with developers, technical managers and application engineers.
            The training is not meant for marketing or non-technical management. The course is technical in nature
            and does not cover the intricate details of mobile payments, mobile wallet and marketing strategy.
          </p>
        </div>

        <div>
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Courseware</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            We offer both a pre-set schedule with substitutions available and a custom course. Navigate the tabs
            below to learn more.
          </p>

          <div className="border-b border-slate-200 flex gap-1">
            {[
              { id: "standard", label: "Standard" },
              { id: "custom", label: "Custom" },
            ].map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`px-6 py-3 text-sm font-semibold transition-colors ${
                  tab === t.id
                    ? "text-[#29abe2] border-b-2 border-[#29abe2] -mb-px"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div className="py-8">
            {tab === "standard" && (
              <div className="space-y-6">
                <h3 className="text-xl font-semibold text-slate-800">Standard</h3>
                <p className="text-slate-600">
                  The following topics will be covered over the 2-day standard workshop:
                </p>
                <div className="grid md:grid-cols-2 gap-8">
                  <DayList
                    day="Day 1"
                    items={[
                      "Session 1: Origins of NFC – How NFC differs from RFID",
                      "Session 2: NFC Tag Technologies",
                      "Session 3: NFC operating modes (read/write, peer to peer, card emulation)",
                      "Session 4: Details of Type 1 and Type 2 Tags",
                    ]}
                  />
                  <DayList
                    day="Day 2"
                    items={[
                      "Session 5: Details of Mifare Classic Tags",
                      "Session 6: How to Detect/Discern NFC Tags Types",
                      "Session 7: How to Read/Write Type 1 Tags",
                      "Session 8: How to Read/Write Type 2 & Mifare Classic Tags",
                    ]}
                  />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-slate-800 mb-3">Optional Substitutions</h4>
                  <p className="text-slate-600 mb-3">
                    The following sessions can be substituted at no extra charge:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 text-slate-600">
                    <li>Type 4 tag operation with specific focus on APDU formats and DESFire security features.</li>
                    <li>NFC Hardware: Review of commercially available NFC readers, controllers, and NFC EEPROMs</li>
                    <li>Android NFC development: Learn about developing NFC applications on Android</li>
                  </ul>
                </div>
                <Link
                  to="/contact-us"
                  className="inline-block bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-widest text-sm px-10 py-3.5 rounded transition-colors mt-4"
                >
                  GET STARTED
                </Link>
              </div>
            )}

            {tab === "custom" && (
              <div className="space-y-5">
                <h3 className="text-xl font-semibold text-slate-800">Custom</h3>
                <p className="text-slate-600">
                  We offer custom workshop catered to your team. Get in touch to start building your course.
                </p>
                <Link
                  to="/contact-us"
                  className="inline-block bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-widest text-sm px-10 py-3.5 rounded transition-colors"
                >
                  GET IN TOUCH
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function DayList({ day, items }) {
  return (
    <div>
      <h4 className="text-lg font-semibold text-slate-800 mb-3">{day}</h4>
      <ul className="space-y-2 text-slate-600">
        {items.map((i) => (
          <li key={i} className="flex gap-2">
            <span className="text-[#29abe2]">•</span>
            <span>{i}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
